import { useCallback, useEffect } from "react";
import { Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../app/store";
import LoadingIndicator from "../loading/LoadingIndicator";
import { useAuth } from "../signin/auth";
import { getChecklist, selectChecklist, selectItems } from "./checklistSlice";
import ListChecklistItems from "./ListChecklistItems";

interface DisplayChecklistDetailProps {
  checklistID: string
}

function DisplayChecklistDetail(props: DisplayChecklistDetailProps) {
  const auth = useAuth();
  const dispatch = useDispatch<AppDispatch>();
  const { checklistID } = props;
  const checklist = useSelector((state: RootState) => selectChecklist(state));
  const items = useSelector((state: RootState) => selectItems(state));
  const checklistStatus = useSelector((state: RootState) => state.checklist.status)
  const checklistError = useSelector((state: RootState) => state.checklist.error)

  const loadChecklistData = useCallback(() => {
    if (auth.authToken) {
      dispatch(getChecklist({
        authToken: auth.authToken,
        checklistID: checklistID,
        includeItems: true,
      }));
    }
  }, [dispatch, auth.authToken, checklistID]);

  useEffect(() => {
    loadChecklistData();
  }, [dispatch, auth.authToken, checklistID, loadChecklistData]);

  const onItemCompleteChecked = (completed: Boolean) => {
    loadChecklistData();
  }

  return (
    <>
      {checklistStatus === 'loading' && <LoadingIndicator />}
      {checklistError && <div>{checklistError}</div>}
      {checklist && (
        <Table striped className="mt-3">
          <tbody>
            <tr>
              <th>ID</th>
              <td><code>{checklist.id}</code></td>
            </tr>
            <tr>
              <th>Name</th>
              <td>{checklist.name}</td>
            </tr>
          </tbody>
        </Table>
      )}
      <>
        <h2>Items</h2>
        <ListChecklistItems checklistID={checklistID} items={items} onItemCompleteChecked={onItemCompleteChecked} />
      </>
    </>
  )
}

export default DisplayChecklistDetail;